module.exports = __webpack_public_path__ + "static/media/loseLarge60_1.52f565af.svg";